const factorAuth = {
    'title': 'Unlock Authority',
    'id_no': 'ID No.(Last 4 digits)',
    'data': 'Verify Data',
    'verification_failed': 'Verification Failed',
};

export default factorAuth;
